import { Flex, type FlexProps } from "@chakra-ui/react";
import { type ChainFullId, ChainFullIds, MAINNET, type Network } from "@umami/chains";
import { useIsSaplingEnabled } from "@umami/state";

import { NetworkSelectorItem } from "./NetworkSelectorItem";

type NetworkSelectorListProps = {
  chains: Network[];
  onSelectChain: (chainId: ChainFullId, isSapling?: boolean) => void;
  isLedger?: boolean;
} & FlexProps;

export const NetworkSelectorList = ({
  chains,
  onSelectChain,
  isLedger = false,
  ...props
}: NetworkSelectorListProps) => {
  const isSaplingEnabled = useIsSaplingEnabled()();

  return (
    <Flex flexDirection="column" overflowY="scroll" {...props}>
      {isSaplingEnabled && !isLedger && (
        <NetworkSelectorItem
          chain={MAINNET}
          name="Shielded Tezos"
          onSelectChain={() => onSelectChain(ChainFullIds.TEZOS, true)}
        />
      )}
      {chains.map(chain => (
        <NetworkSelectorItem
          key={chain.identifier + chain.namespace}
          chain={chain}
          onSelectChain={onSelectChain}
        />
      ))}
    </Flex>
  );
};
